import { ReactNode } from "react";
import { useTranslation } from "react-i18next";

type Props = {
  children: ReactNode;
};

export const ParametersHeader = ({ children }: Props) => {
  const { t } = useTranslation("shared");
  return (
    <div className="flex h-fit w-full flex-1 flex-col gap-4 p-8">
      <div className="flex w-full flex-col gap-2">
        <h1 className="font-jakarta-sans text-3xl font-semibold">{t("parametersHeader.title")}</h1>
        <p>{t("parametersHeader.subtitle")}</p>
      </div>
      {children}
    </div>
  );
};
